function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/navigation/ic-arrow-back");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M19,11 L7.83,11 L12.7124956,6.11750442 C13.1018612,5.7281388 13.1018612,5.0968524 12.7124956,4.70748678 C12.7116652,4.70665638 12.7108333,4.70582746 12.71,4.705 L12.707098,4.7021184 C12.316175,4.31394844 11.6849363,4.3150637 11.2953874,4.70461259 L4.70710678,11.2928932 C4.31658249,11.6834175 4.31658249,12.3165825 4.70710678,12.7071068 L11.295,19.295 C11.6843607,19.6843607 12.3156393,19.6843607 12.705,19.295 L12.705,19.295 C13.0944628,18.9055372 13.0947454,18.2741804 12.7056314,17.8843691 L7.83,13 L19,13 C19.5522847,13 20,12.5522847 20,12 L20,12 C20,11.4477153 19.5522847,11 19,11 Z",
  id: "path-arrow-back"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "icon/navigation/ic-arrow-back",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-arrow-back"
})), React.createElement("use", {
  id: "icon/navigation/arrow_back_24px",
  fill: "#333340",
  xlinkHref: "#path-arrow-back"
}));

var SvgIcArrowBack = function SvgIcArrowBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcArrowBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-arrow-back.43d012d7.svg";
export { ForwardRef as ReactComponent };